import React from 'react';
import { Icon } from '../../components';
import {UserNotificationBadge} from '../..//ui/components/NotificationBadge';
import { connect } from 'react-redux';
import Theme from '../../theme';
import {toggleNutritionStepsModal} from '../../ui';
import { defaultScale } from '../../utils/scaling';
import { TouchableOpacity, View, StyleSheet } from 'react-native';

const NutritionHelpIcon = ({ navigation , toggleNutritionStepsModal }) => {
  return (
    <View style={styles.container}>
      <TouchableOpacity onPress={() => {toggleNutritionStepsModal(true); }}>
        <Icon
          size={defaultScale(25)}
          name='ios-help-circle-outline'
          style={{ color: Theme.GREY_DARK }}
        ></Icon>
      </TouchableOpacity>
     <UserNotificationBadge navigation= {navigation}/>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1, 
      flexDirection: 'row', 
      justifyContent: 'center',
      alignItems: 'center',
  },
});

const mapDispatchToProps = (dispatch) => {
  return{
    toggleNutritionStepsModal: (visible) => dispatch(toggleNutritionStepsModal(visible)),
    toggleDieticianModal: (visible) => dispatch(toggleDieticianModal(visible)),
  };
};
export default connect(null, mapDispatchToProps)(NutritionHelpIcon);
